import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7l16 0","key":"svg-0"}],["path",{"d":"M4 17l16 0","key":"svg-1"}],["path",{"d":"M7 4l0 16","key":"svg-2"}],["path",{"d":"M17 4l0 16","key":"svg-3"}]]

const IconFrame = createReactComponent('outline', 'frame', 'Frame', __iconNode);

export default IconFrame;